/* eslint-disable camelcase */

/* eslint-disable max-statements */
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { TabPanel, TabView, TabViewTabChangeParams } from 'primereact/tabview';
import QuickLinks from '../../components/customProgressBar/QuickLinks';
import { MetricTargetsResult } from '../../components/customProgressBar/types';
import MessageInfo from '../../components/messageInfo/MessageInfo';
import MetricSlider from '../../components/metricSlider/MetricSlider';
import RankingCard from '../../components/rankingCard/RankingCard';
import { StackRankCard } from '../../components/rankingCard/StackRankCard';
import { ScoreCardFilter } from '../../components/scoreCardFilter/ScoreCardFilter';
import { StackRankDashboardTable } from '../../components/stackRankDashboardTable/StackRankDashboardTable';
import { AGENTROLE, MANAGERROLE, SUPERVISORROLE } from '../../constants';
import { ConstApplicationRole, ConstScorecardRole } from '../../utils/typeConstants';
import { selectCurrentEmpid, selectCurrentIsAdmin, selectCurrentIsEds, selectCurrentRole } from '../login/authSlice';
import { useGetMetricTargetsQuery } from '../metricdashboard/metricDashboardSlice';
import {
    useGetTeamLeadScoreCardsQuery,
    useGetstackRankSearchQuery,
} from '../scorecardDashboard/scorecardDashboardSlice';
import './stackRank.scss';
import { saveSCfilDate, loadSCfilDate } from '../../utils/dateStorage';
import { MetricDetail, RankingItem, View, extractAndSortMetricDetailsById, getNameById } from './types';
import AttainmentChart from '../../components/customProgressBar/AttainmentChart';
import TieredAttainmentChart from '../../components/customProgressBar/TieredAttainmentChart';
import { isTieredScorecard } from '../../utils/metricAttainment';
import { StackRankBandColors } from '../../utils/stackRankColors';

export const StackRank = () => {
    const { eid, svid, year, month } = useParams();
    const role = useSelector(selectCurrentRole);
    const isAdmin = useSelector(selectCurrentIsAdmin);
    const isEds = useSelector(selectCurrentIsEds);
    const [date, setDate] = useState(new Date());
    const [scorecardVersionID, setScorecardVersionID] = useState<number | string>(0);
    const empNum = useSelector(selectCurrentEmpid);
    const [scorecardDisable, setScorecardDisable] = useState(false);
    const [selectedView, setSelectedView] = useState<View>({ name: 'Global', code: '1' });
    const [stackRankData, setStackRankData] = useState<any>(null);

    const [supervisors, setSupervisors] = useState<{ label: string; value: string }[]>([]);
    const [managers, setManagers] = useState<{ label: string; value: string }[]>([]);
    const [selectedSupervisor, setSelectedSupervisor] = useState<string | null>(null);
    const [selectedManager, setSelectedManager] = useState<string | null>(null);

    //need to set the values based on scorecard filters
    const [inputMonth, setInputMonth] = useState(new Date().getMonth() + 1);
    const [inputYear, setInputYear] = useState(new Date().getFullYear());

    const [metricId, setMetricId] = useState(0);
    const [metricType, setMetricType] = useState('');
    const [selectedMetric, setSelectedMetric] = useState<string>('');

    const [metricTargetsData, setMetricTargetsData] = useState<MetricTargetsResult | null>(null);

    const [agentNumber, setAgentNumber] = useState(empNum);
    const [supervisorNumber, setSupervisorNumber] = useState(0);
    const [metricContent, setMetricContent] = useState<any>('');
    const [metricSmiley, setMetricSmiley] = useState<any>('');
    const [allRankingData, setAllRankingData] = useState<any>([]);
    const [top3RankingData, setTop3RankingData] = useState<any>([]);
    const [selectedUserInGrid, setSelectedUserInGrid] = useState<any>(null);
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [scorecardRoleId,setScorecardRoleId ] = useState<number>(1);
    const [loggedInUserRecord, setLoggedInUserRecord] = useState<any>(null);
    const [showNonPayoutMetrics, setShowNonPayoutMetrics] = useState<boolean>(false);

    useEffect(() => {
        if (role === SUPERVISORROLE) {
            setSupervisorNumber(parseInt(empNum, 10));
        } else if (role === AGENTROLE) {
            setAgentNumber(parseInt(empNum, 10));
            const supNum = stackRankData?.find(
                (item: any) => item.employee_number === empNum
            )?.supervisor_number;
            setSupervisorNumber(parseInt(supNum, 10));
        }
        if (svid) setScorecardVersionID(svid);
        if (year) setInputYear(parseInt(year, 10));
        if (month) setInputMonth(parseInt(month, 10));
        if (month && year) {
            setDate(new Date(`${year}-${month}`));
        } else {
            const storedDate = loadSCfilDate();
            if (storedDate) {
                setDate(storedDate);
                setInputMonth(storedDate.getMonth() + 1);
                setInputYear(storedDate.getFullYear());
            }
        }
    }, [eid, svid, year, month]);

    useEffect(() => {
        if (role === SUPERVISORROLE) {
            setSupervisorNumber(parseInt(empNum, 10));
        } else if (role === AGENTROLE) {
            setAgentNumber(parseInt(empNum, 10));
            const supNum = stackRankData?.find(
                (item: any) => item.employee_number === empNum
            )?.supervisor_number;
            setSupervisorNumber(parseInt(supNum, 10));
        }
    }, [role, empNum, stackRankData]);
    useEffect(() => {
        if(loggedInUserRecord && Object.keys(loggedInUserRecord).length > 0){
            setSelectedUserInGrid(loggedInUserRecord);
        } else
        setSelectedUserInGrid(null);
    },[inputMonth,inputYear])

    const { data: stackRankSearchData } = useGetstackRankSearchQuery(
        {
            // employeenumber: null,
            employeenumber: parseInt(empNum, 10),
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: scorecardVersionID,
            ScorecardRoleId:scorecardRoleId,
            showNonPayoutMetrics
        },
        { skip: !empNum || !scorecardVersionID || !inputMonth || !inputYear || !scorecardRoleId }
    );

    const { data: teamLeadScoreCardsDataValue } = useGetTeamLeadScoreCardsQuery(
        {
            employeenumber: empNum,
            year: inputYear,
            month: inputMonth,
            applicationRoleId:
                role === SUPERVISORROLE ? ConstApplicationRole.TEAM_LEAD : ConstApplicationRole.ASSOCIATE,
        },
        { skip: !empNum || !inputMonth || !inputYear || role === MANAGERROLE}
    );

    const { data: metricTargetsSliceData } = useGetMetricTargetsQuery(
        {
            AgentNumber:scorecardRoleId === ConstScorecardRole.ASSOCIATE ? agentNumber:0,
            SupervisorNumber: supervisorNumber??0,
            Year: inputYear,
            Month: inputMonth,
            ScorecardVersionId: scorecardVersionID,
            MetricId: metricId,
        },
        { skip: !inputMonth || !inputYear || !scorecardVersionID || !metricId || metricId === 0 }
    );

    useEffect(() => {
        if (metricTargetsSliceData?.data) {
            setMetricTargetsData(metricTargetsSliceData?.data[0]);
        } else {
            setMetricTargetsData(null);
        }
    }, [metricTargetsSliceData]);
    useEffect(() => {
        if (selectedUserInGrid) {
            if(scorecardRoleId === ConstScorecardRole.ASSOCIATE){
                setAgentNumber(selectedUserInGrid?.employee_number);
                setSupervisorNumber(selectedUserInGrid?.supervisor_number);
            }
            else if(scorecardRoleId === ConstScorecardRole.TEAM_LEAD){
                setAgentNumber(selectedUserInGrid?.employee_number);
                setSupervisorNumber(selectedUserInGrid?.employee_number);
            }

            
        }
    }, [selectedUserInGrid]);

    const DateOnChange = (e: any) => {
        setDate(e.value);
        setInputMonth(e.value.getMonth() + 1);
        setInputYear(e.value.getFullYear());
        setScorecardVersionID(0);
        saveSCfilDate(e.value);
    };

    const ScorecardOnChange = (e: any) => {
        setScorecardVersionID(e.value);
    };

    useEffect(() => {
        if (teamLeadScoreCardsDataValue?.data.length > 0) {
            setScorecardDisable(false);
            setScorecardVersionID(teamLeadScoreCardsDataValue?.data[0].scorecard_version_id);
        } else if (!isEds) {
            setScorecardDisable(true);
        }
    }, [teamLeadScoreCardsDataValue, isEds]);

    useEffect(() => {
        if (stackRankSearchData?.status && stackRankSearchData?.data) {
            const uniqueSupervisors = new Map<string, string>();
            const uniqueManagers = new Map<string, string>();

            stackRankSearchData.data.forEach((item: any) => {
                if (!uniqueSupervisors.has(item.supervisor_number)) {
                    uniqueSupervisors.set(item.supervisor_number, item.supervisor_name);
                }
                if (!uniqueManagers.has(item.manager_number)) {
                    uniqueManagers.set(item.manager_number, item.manager_name);
                }
            });

            // Convert maps to sorted dropdown options. localeCompare guards against null here -
            // supervisor_name/manager_name can be null (e.g. a row with no supervisor/manager,
            // such as the top of the org hierarchy), and .sort() previously crashed on that.
            const sortedSupervisors = Array.from(uniqueSupervisors, ([value, label]) => ({
                label,
                value,
            })).sort((a, b) => (a.label || '').localeCompare(b.label || ''));
            const sortedManagers = Array.from(uniqueManagers, ([value, label]) => ({ label, value })).sort(
                (a, b) => (a.label || '').localeCompare(b.label || '')
            );

            setSupervisors(sortedSupervisors);
            setManagers(sortedManagers);
        }
    }, [stackRankSearchData,scorecardRoleId]);

    useEffect(() => {
        if (
            scorecardVersionID !== '' &&
            Number(scorecardVersionID) > 0 &&
            selectedView &&
            stackRankSearchData?.data?.length > 0
        ) {
            let filtered = Array.isArray(stackRankSearchData.data) ? [...stackRankSearchData.data] : []; // Ensure it's always an array

            if (selectedView?.code === '2' && selectedSupervisor) {
                filtered = filtered.filter((agent) => agent.supervisor_number === selectedSupervisor);
            } else if (selectedView?.code === '3' && selectedManager) {
                filtered = filtered.filter((agent) => agent.manager_number === selectedManager);
            }

            if (!selectedUserInGrid) {
                const loggedInUserRecord = stackRankSearchData.data.find(
                    (row: any) => row.employee_number === (eid || empNum)
                );
                setLoggedInUserRecord(loggedInUserRecord);
                setSelectedUserInGrid(loggedInUserRecord);
            }
            // Filter metrics for ALL employees based on toggle state
            const filteredData = filtered.map((employee: any) => ({
                ...employee,
                agentMetrics: employee.agentMetrics.map((am: any) => ({
                    ...am,
                    metricsDetails: showNonPayoutMetrics
                        ? am.metricsDetails
                        : Object.fromEntries(
                            Object.entries(am.metricsDetails).filter(([, metric]: [string, any]) =>
                                metric.is_payout_metric === true
                            )
                        )
                }))
            }));
            setStackRankData(filteredData);
        }
    }, [selectedSupervisor, selectedManager, selectedView, stackRankSearchData, scorecardRoleId, showNonPayoutMetrics]);

    const onScoreCardChange = (value: any) => {
        setSelectedUserInGrid(loggedInUserRecord);
        if (value !== undefined && value !== '' && value !== null) {
            if (value.month !== '') setInputMonth(value.month);
            if (value.year !== '') setInputYear(value.year);
            setScorecardVersionID(value.scorecardVersionId);
        } else {
            setInputMonth(new Date().getMonth() + 1);
            setInputYear(new Date().getFullYear());
            setScorecardVersionID('');
            onStackRankReset();
        }
    };

    const onStackRankReset = () => {
        setStackRankData(null);
        setSupervisors([]);
        setManagers([]);
        setSelectedView({ name: 'Global', code: '1' });
        setSelectedSupervisor(null);
        setSelectedManager(null);
        setLoggedInUserRecord(null);
        setSelectedUserInGrid(null);
        setShowNonPayoutMetrics(false);
    };

    ////////////////////////////

    

    useEffect(() => {
        if (stackRankData?.length > 0) {
            const { all, top3 } = extractAndSortMetricDetailsById(
                stackRankData,
                metricId,
                selectedUserInGrid,
                empNum
            );

            setTop3RankingData(top3);
            setAllRankingData(all);
        } else {
            setAllRankingData([]);
            setTop3RankingData([]);
        }

    }, [stackRankData, metricId,selectedUserInGrid,selectedMetric,selectedView]);
    ////////////////////////////

    const originalData = stackRankSearchData?.data || [];
    const allMetricsDetails = originalData.length > 0 && originalData[0]?.agentMetrics[0]?.metricsDetails;
    const nonPayoutMetricsCount = useMemo(() => {
        if (!allMetricsDetails) return 0;
        return Object.values(allMetricsDetails).filter(
            (metric: any) => metric.is_payout_metric === false
        ).length;
    }, [allMetricsDetails]);
    const showToggle = nonPayoutMetricsCount > 0;
    const filteredMetricsDetails = useMemo(() => {
        if (!allMetricsDetails) return {};
        if (showNonPayoutMetrics) return allMetricsDetails; // Show all

        // Show only payout metrics when toggle OFF
        return Object.fromEntries(
            Object.entries(allMetricsDetails).filter(([, metric]: [string, any]) => metric.is_payout_metric === true)
        );
    }, [allMetricsDetails, showNonPayoutMetrics]);

    const response = filteredMetricsDetails;


    const metricArray = Object.entries(response).map(([metricName, details]) => {
        const metricDetail = details as MetricDetail; // Type assertion
        let userName = '';
        if (selectedUserInGrid && Object.keys(selectedUserInGrid).length > 0) {
            if (selectedUserInGrid?.employee_number === empNum) {
                userName = 'I';
            } else {
                const employeeName = selectedUserInGrid?.employee_name || '';
                userName = employeeName.startsWith('Anonymous')
                    ? employeeName
                    : `${selectedUserInGrid?.first_name} ${selectedUserInGrid?.last_name}`;
            }
        } else if (role === AGENTROLE) {
            userName = 'I';
        }
        return {
            id: metricDetail.metric_id,
            name: metricName,
            type: metricDetail.metric_type_name,
            content: `${metricContent}`,
            agentName: userName,
            smiley: metricSmiley,
        };
    });

    useEffect(() => {
        if (allRankingData?.length > 0) {
            const allRankingDatawithSelectedAgent = allRankingData.map((item: any) => ({
                ...item,
                color: agentNumber === item.id ? '#ECECFE' : '#FFFFFF',
            }));
            setAllRankingData(allRankingDatawithSelectedAgent);
        }
    }, [agentNumber]);

    const handleMetricChange = (id: number, type: string) => {
        setMetricId(id);
        setMetricType(type);
        setSelectedMetric(getNameById(metricArray, id));
    };

    // Color index for the tiered chart - the selected metric's position among the currently
    // displayed metrics, same convention used everywhere else (colorIndex % palette length).
    const selectedMetricColorIndex = useMemo(() => {
        const idx = metricArray.findIndex((m) => m.id === metricId);
        return idx >= 0 ? idx % StackRankBandColors.length : 0;
    }, [metricArray, metricId]);

    // P4P multi-tier (E20-6317): the resolved accent color for the currently selected metric,
    // shared by the grid's selected row and the ranking cards' selected employee, so both stay
    // visually in sync with whichever metric is currently being viewed rather than using one
    // fixed color regardless of metric. "meets" is used as this metric's single representative
    // identity color for a non-status-driven UI element (there's no single "the metric's color"
    // otherwise, since the palette is inherently 3 status shades per metric).
    const selectedMetricAccentColor = useMemo(
        () => (StackRankBandColors[selectedMetricColorIndex] ?? StackRankBandColors[0]).meets,
        [selectedMetricColorIndex]
    );

    const onTabChange = (e: TabViewTabChangeParams) => {
        setActiveIndex(e.index);
        let role=0  ;
        if (e.index === 0) {
            role = ConstScorecardRole.ASSOCIATE;
        } else if (e.index === 1) {
            role = ConstScorecardRole.TEAM_LEAD;
        }
        setScorecardRoleId(role);
        onStackRankReset();
        setSelectedUserInGrid(null);
    };
   

    return (
        <>
        


            <div className="row mt-0">
                <div className="col-12">
                    <div className="card-body">
                        {(isAdmin || isEds || role === MANAGERROLE) && (
                            <div>
                                <ScoreCardFilter
                                    menuName={'StackRank'}
                                    scorecardData={onScoreCardChange}
                                    filterSCValue={setScorecardVersionID}
                                    filterMonth={setInputMonth}
                                    filterYear={setInputYear}
                                />
                            </div>
                        )}

                        {!isAdmin && !isEds && (role === SUPERVISORROLE || role === AGENTROLE) && (
                            <div className="row mt-4">
                                <div className="col-md-3">
                                    <div className="content rounded-border w-300">
                                        <label htmlFor="month">Select Date</label>
                                        <Calendar
                                            value={date}
                                            onChange={DateOnChange}
                                            view="month"
                                            maxDate={new Date()}
                                            showIcon
                                            className="custom-calendar me-4"
                                            dateFormat="MM, yy"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="content rounded-border w-300">
                                        <label htmlFor="scorecard">Select Scorecard</label>
                                        <Dropdown
                                            disabled={scorecardDisable}
                                            value={scorecardVersionID}
                                            onChange={ScorecardOnChange}
                                            options={teamLeadScoreCardsDataValue?.data}
                                            optionValue={'scorecard_version_id'}
                                            optionLabel={'scorecard_name'}
                                            placeholder={'No Scorecards'}
                                            className="custom-dropdown me-4"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div >
            {(role === SUPERVISORROLE || role === MANAGERROLE)  && <TabView activeIndex={activeIndex} onTabChange={onTabChange}>
                <TabPanel header="Associate" />
                <TabPanel header="Team Lead" />
            </TabView>   }       
            </div>          
            {scorecardVersionID !== '' &&
            Number(scorecardVersionID) > 0 &&
            selectedView &&
            stackRankData?.length > 0 ? (
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="p-card card shadow bg-body rounded border-0">
                            <div>
                                <img
                                    style={{ width: '-webkit-fill-available' }}
                                    src="/stackRankTOPBanner.png"
                                    alt=""
                                />
                            </div>
                            <div className="metric-target-container">
                                <div className="left" style={{ maxWidth: '40%' }}>
                                    <MetricSlider
                                        metrics={metricArray}
                                        onMetricChange={handleMetricChange}
                                        isTiered={isTieredScorecard(stackRankData?.[0]?.scorecard_calculation_rule_id)}
                                    />
                                </div>
                                <div className="middle">
                                    <QuickLinks />
                                </div>
                                <div className="right">
                                    {metricTargetsData && (
                                        isTieredScorecard(metricTargetsData?.scorecardCalculationRuleId) ? (
                                            <TieredAttainmentChart
                                                data={metricTargetsData}
                                                selectedUserInGrid={selectedUserInGrid}
                                                empNum={empNum}
                                                metricType={metricType}
                                                scorecardRoleId={scorecardRoleId}
                                                colorIndex={selectedMetricColorIndex}
                                            />
                                        ) : (
                                            <AttainmentChart
                                                data={metricTargetsData}
                                                selectedUserInGrid={selectedUserInGrid}
                                                empNum={empNum}
                                                metricType={metricType}
                                                scorecardRoleId={scorecardRoleId}
                                            />
                                        )
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="dashboard-container">
                                {/* Left Side - Ranking Cards */}

                                <div
                                    className="p-card card shadow bg-body border-0 ranking-list-container"
                                    style={{ borderRadius: '25px' }}
                                >
                                    <div className="ranking-list1" style={{ maxWidth: '400px' }}>
                                        <StackRankCard
                                            data={top3RankingData}
                                            selectedMetric={selectedMetric}
                                        />
                                    </div>
                                    <div className="ranking-list2">
                                        {allRankingData.map((card: RankingItem) => (
                                            <RankingCard
                                                key={card.employee_name}
                                                {...card}
                                                selectedMetric={selectedMetric}
                                                isTiered={isTieredScorecard(stackRankData?.[0]?.scorecard_calculation_rule_id)}
                                                selectedMetricColor={selectedMetricAccentColor}
                                            />
                                        ))}
                                    </div>
                                </div>
                                <div
                                    className="card shadow bg-body border-0 table-container"
                                    style={{ borderRadius: '25px', padding: '15px' }}
                                >
                                    <StackRankDashboardTable
                                        stackRankSearchData={stackRankData}
                                        selectedMetric={selectedMetric}
                                        setMetricContent={setMetricContent}
                                        setMetricSmiley={setMetricSmiley}
                                        setSelectedUserInGrid={setSelectedUserInGrid}
                                        selectedUserInGrid={selectedUserInGrid}
                                        setSelectedSupervisor={setSelectedSupervisor}
                                        setSelectedManager={setSelectedManager}
                                        setSelectedView={setSelectedView}
                                        supervisors={supervisors}
                                        managers={managers}
                                        scorecardRoleId={scorecardRoleId}
                                        inputMonth={inputMonth}
                                        inputYear={inputYear}
                                        scorecardVersionID={scorecardVersionID}
                                        showNonPayoutMetrics={showNonPayoutMetrics}
                                        setShowNonPayoutMetrics={setShowNonPayoutMetrics}
                                        shouldShowToggle={showToggle}
                                        selectedRowColor={selectedMetricAccentColor}

                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <MessageInfo
                    title="No results found."
                    message="Try adjusting the month or scorecard filter above."
                    rowHeight="200px"
                />
            )}
        </>
    );
};
